export const SeverityLevels = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info"
};


export const CustomerAction = {
    CREATE_CUSTOMER: "create_customer",
    LOG_IN: "Log_In"
};


export const CategoryFilter = {
    MOVE_IN: 'move-in',
    MOVE_OUT: 'move-out',
    TENANCIES: 'tenancies',
    REPORTS: 'reports',
    SCANS: 'scans',
    UNITS: 'units',
    SCANS_DONE: 'scans_done',
    SCANS_LOGS: 'scans_logs',
    INSPECTION_JOURNEYS: 'journeys',
    INSPECTION_SCHEDULES: 'inspection_schedules',
};

export const MODAL_TYPES = {
    VIDEO_MODAL: 'videoModal',
    UPLOADER_MODAL: 'uploaderModal',
    TENANT_SCAN_UPLOADER_MODAL: 'tenantScanUploaderModal',
    ALL_REPORTS_MODAL: 'allReportsModal',
    ALL_TENANCIES_MODAL: 'allTenanciesModal',
    UPDATE_UNIT_ADDRESS_MODAL: 'updateUnitsAddressModal',
    UPDATE_UNIT_REFERENCE_MODAL: 'updateUnitReferenceModal',
    DELETE_UNIT_MODAL: 'deleteUnitModal',
    APPROVE_MODAL: 'approveModal',
    REJECT_MODAL: 'rejectModal',
    ADD_UNIT_MODAL: 'addUnitModal',
    ADD_TENANCY_MODAL: 'addTenancyModal',
    BULK_UPLOAD: 'bulkUploadModal',
    SEARCH_FILTER_UPLOAD: 'searchFilterModal',
    DELETE_JOURNEY_MODAL: 'deleteJourneyModal',
    EDIT_JOURNEY_MODAL: 'editJourneyModal',
    CREATE_SCHEDULE_MODAL: 'createScheduleModal',
    EDIT_SCHEDULE_MODAL: 'editScheduleModal',
    DELETE_SCHEDULE_MODAL: 'deleteScheduleModal',
    UPDATE_TENANCY_MODAL: 'updateTenancyModal',
    DELETE_TENANCY_MODAL: 'deleteTenancyModal',
    SEND_EMAIL_MODAL: 'sendEmailModal',
    REPROCESS_INSPECTION_MODAL: 'reProcessInspection',
};

export const INSPECTION_TYPES = {
    BASELINE: 'baseline',
    MOVE_IN: 'checkin',
    MOVE_OUT: 'checkout',
};

export const ReportsCategory = {
    INVENTORY: 'inventory',
    DEFECTS: 'defects',
    ORGANIZATION: 'organization',
    CENTRALIZED: 'centralized',
};

export const InventoryCategory = {
    ALL: 'All',
};

export const PROPERTY_ROLE = {
    OWNER: 'owner',
    MAINTENANCE: 'maintenance',
    RESIDENT: 'resident',
};

export const WRITABLE_PMS = {
    APPFOLIO: 'appfolio',
    BUILDIUM: 'buildium',
}

export const DATE_FORMAT = navigator.language === "en-US" ? 'mm/dd/yyyy' : "dd/mm/yyyy";
export const DATETIME_FORMAT = navigator.language === "en-US" ? 'mm/dd/yyyy H:MM tt' : "dd/mm/yyyy HH:MM";

// 3rd party
export const INTERCOM_APP_ID = 'bvtnty4v';